import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test',
  templateUrl: './Test.component.html',
  styleUrls: ['./Test.component.css']
})
export class TestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
